// extracted by mini-css-extract-plugin
export var auto = "_3z-1";
export var spinner = "_3z-0";